import { render, staticRenderFns } from "./CourtBaseInfo.vue?vue&type=template&id=8579f54a&scoped=true&"
import script from "./CourtBaseInfo.vue?vue&type=script&lang=js&"
export * from "./CourtBaseInfo.vue?vue&type=script&lang=js&"
import style0 from "./CourtBaseInfo.vue?vue&type=style&index=0&id=8579f54a&prod&lang=css&"
import style1 from "./CourtBaseInfo.vue?vue&type=style&index=1&id=8579f54a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8579f54a",
  null
  
)

export default component.exports